const hamburgerButton = document.querySelector('.header__hamburger');
const menu = document.querySelector('.header__menu');
const website = document.querySelector('html');
const header = document.querySelector('.website__header');
let lastScrollY = window.scrollY;
let ticking = false;

hamburgerButton.addEventListener('click', function () {
    menu.classList.toggle('active');
    website.classList.toggle('has-active-menu');
    hamburgerButton.classList.toggle('active');
});

function handleHeaderScroll() {
    const currentScrollY = window.scrollY;
    const isScrollingDown = currentScrollY > lastScrollY;

    if (currentScrollY <= 5) {
        header.classList.remove('hidden');
    } else {
        header.classList.toggle('hidden', isScrollingDown);
    }

    lastScrollY = currentScrollY;
    ticking = false;
}

function onScrollOrTouch() {
    if (!ticking) {
        requestAnimationFrame(handleHeaderScroll);
        ticking = true;
    }
}

function handleMouseMove(event) {
    if (event.clientY < 70) {
        header.classList.remove('hidden');
    }
}

window.addEventListener('scroll', onScrollOrTouch);
window.addEventListener('mousemove', handleMouseMove);
